<span class="cm-label" [title]="$label()">{{ $label() }}</span>
<label [hidden]="!$editingEnabled()" class="cm-color-picker" [style.background]="valueString">
    <input name="colorPicker" #colorPicker type="color" [(ngModel)]="valueString" />
</label>
